
export const companyLink = (exchange, symbol) => {
  const symbolWithDashes = symbol.replace("\.", "-");
  return `/e/${exchange.toLowerCase()}/s/${symbolWithDashes.toLowerCase()}`;
};

export const callLink = (exchange, symbol, year, quarter) => {
  return `${companyLink(exchange, symbol)}/y/${year}/q/${quarter.toLowerCase()}`;
};
